import { Avatar, Box, Card, Grid } from "@mui/material";
import React from "react";
import midBarBackGroundImage from "../../../assets/dashBoard/admin-profile/profile-Background-strip.svg";
import Flex from "../../../components/Flex";
import Text from "../../../components/Text";
import { AdminProfileType } from "../../../constants/AdminProfileFormSchemas";
import { replaceUnderScoreAddSpace } from "../../../utils/utils";

const userSettingStyles = {
  Card: {
    overflow: "visible",
    marginTop: "2em",
    position: "relative",
    borderRadius: "0.6rem",
    width: "40em",
    minHeight: "27.8em",
    paddingBottom: "1.5em",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
};

interface UserProfileProps {
  userProfile: AdminProfileType;
}

const UserProfile: React.FC<UserProfileProps> = ({ userProfile }) => {
  const location = Object.values(userProfile?.workLocations ?? {})
    .map((locationName) => locationName?.trim())
    .filter(Boolean)
    .join(", ");

  return (
    <Box p={1}>
      <Box
        component={"img"}
        src={midBarBackGroundImage}
        position={"relative"}
        width={"100%"}
        top={"8em"}
      />
      <Flex justifyContent={"center"}>
        <Card sx={userSettingStyles.Card}>
          <Avatar
            alt="profile-image"
            src={userProfile?.avatar}
            sx={{
              position: "relative",
              top: "-4em",
              objectFit: "fill",
              width: "11.563rem",
              height: "11.63rem",
              zIndex: 8,
            }}
          />
          <Grid container gap={"0.65rem"}>
            {Object.entries({
              name: `${userProfile?.firstName ?? ""} 
                 ${userProfile?.lastName ?? ""}`,
              "email Id": userProfile?.email ?? "",
              office_phone_number: userProfile?.phone,
              user_type: userProfile?.roleTypeSting ?? "",
              role: userProfile?.roleString ?? userProfile?.role ?? "",
              location: location || "-",
            }).map(([key, value]) => (
              <Grid key={key} marginLeft={"5.8rem"} container>
                <Grid item xs={5.5}>
                  <Text fontWeight={"medium"} color={"#1A1A1A80"}>
                    {replaceUnderScoreAddSpace(key)}
                  </Text>
                </Grid>
                <Grid>: </Grid>
                <Grid item paddingLeft={"1rem"} xs={5.5}>
                  <Text>{value ?? "-"}</Text>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Card>
      </Flex>
    </Box>
  );
};

export default UserProfile;
